import { queryOptions, useQuery } from '@tanstack/react-query';

import { removeLocale } from 'queries/keys.utils';
import { QueryVariables, StaleTime } from 'queries/types';
import { TICKETS_PREFIX } from 'restful/tickets/constants';
import { restCall } from 'services/api/restful/client';
import { RestApiError } from 'services/api/restful/errors';
import type { Event } from 'services/api/restful/generated/nofomoRestApi.schemas';
import { getEvent } from 'services/api/restful/generated/tickets/tickets';

type TicketsEventQueryData = { event?: Event };

export const ticketsEventQuery = (variables: {
  id: string;
  timeslotId: string;
}) =>
  queryOptions<TicketsEventQueryData, RestApiError>({
    queryKey: [TICKETS_PREFIX, 'event', removeLocale(variables)],
    queryFn: async () => {
      const { data } = await restCall(() =>
        getEvent(
          variables.id,
          variables.timeslotId
            ? { timeslotId: variables.timeslotId }
            : undefined,
        ),
      );

      return {
        event: data,
      };
    },
  });

export const useTicketsEvent = (
  variables: QueryVariables<typeof ticketsEventQuery>,
  config: Partial<ReturnType<typeof ticketsEventQuery>>,
) => {
  const { data } = useQuery({
    ...ticketsEventQuery(variables),
    staleTime: StaleTime.FOREVER,
    ...config,
  });

  return {
    data: data?.event,
  };
};
